import { prop } from '@ipfabric/utils/fp/prop';
import classNames from 'classnames';
import { useGlobalStateContextSelectors } from 'components/GlobalState/GlobalStateModel';
import { PortalToContainer } from 'components/PortalToContainer/PortalToContainer';
import type { FC, ReactNode } from 'react';

type Props = {
  children: ReactNode;
  contentClassName?: string;
};

export const ModalFullContent: FC<Props> = (props) => {
  const { contentWrapper } = useGlobalStateContextSelectors({
    contentWrapper: prop('contentWrapper'),
  });
  return (
    <PortalToContainer container={contentWrapper}>
      <div
        className={classNames(
          props.contentClassName,
          'match-parent z-popup flex flex-col bg-[#ecf0f5]',
        )}
      >
        {props.children}
      </div>
    </PortalToContainer>
  );
};
